<template>
  <section class="group">
    <div class="card" style="border-radius: 8px; box-shadow: none">
      <div class="card-header">
        <div class="group-menu">
          <div class="group-menu__header">
            <p @click="fly()" class="card-header-title is-semibold-16-600-19" :class="{ active: isActive }">
              <!-- title="Fly to Map" -->
              <!-- style="font-weight:500;font-size:16px" -->
              <span class="flyto-btn">
                <i class="far fa-paper-plane"></i>
              </span>
              <span v-tooltip="group[0].groupName">{{ group[0].groupName }}</span>
            </p>
            <a class="card-header-icon" @click="open = !open">
              <svg viewBox="0 0 100 100" class="image is-24x24 mr-10">
                <use v-if="!open" xlink:href="@/assets/icons/sprite.svg#collapse" />
                <use v-else xlink:href="@/assets/icons/sprite.svg#expand" />
              </svg>
            </a>
          </div>
          <div class="group-menu__content">
            <div class="group-menu__content-row">
              <div class="field">
                <input v-model="is_ortho" :checked="is_ortho" class="is-checkradio is-outlined is-small is-info"
                  type="checkbox" :id="'map-group' + group[0].groupUid" />
                <label class="label" :for="'map-group' + group[0].groupUid">{{ localization("app-maps", "Maps")
                }}</label>
              </div>
              <div class="field">
                <input @change="SET_GROUP_VECTOR({ group, active: is_vector })" v-model="is_vector" :checked="is_vector"
                  class="is-checkradio is-small is-info" type="checkbox" :id="'vector-group' + group[0].groupUid" />
                <label class="label" :for="'vector-group' + group[0].groupUid">{{ localization("app-issues", "Issues")
                }}</label>
              </div>
              <div class="field">
                <input @change="SET_GROUP_TABLES({ group, active: is_table })" v-model="is_table" :checked="is_table"
                  class="is-checkradio is-small is-info" type="checkbox" :id="'tables-group' + group[0].groupUid" />
                <label class="label" :for="'tables-group' + group[0].groupUid">{{ localization("app-racks", "Racks")
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="{ 'card-content-close': !open }" class="card-content">
        <project v-for="(project, i) in sort(group)" :key="project.projectUid" :is_group_ortho="is_ortho"
          :is_group_vector="is_vector" :is_group_table="is_table" :project="project" :index="i" :group_index="index">
        </project>
      </div>
    </div>
  </section>
</template>
<script>
import Project from "./project.component";
import { mapGetters, mapState, mapMutations } from "vuex";
import _ from "lodash";
export default {
  props: ["group", "index"],
  data: function () {
    return {
      is_ortho: false,
      is_vector: false,
      is_table: false,
      open: false,
    };
  },
  created() {
  },
  methods: {
    ...mapMutations(["SET_GROUP_VECTOR", "SET_GROUP_TABLES", "SET_CLUSTER_ACTIVE_LAYER"]),
    sort(data) {
      if (!data) return [];
      return _.orderBy(data, [(p) => (p.properties || {}).date, (p) => p.projectName], ["desc", "asc"]);
    },
    fly() {
      if (this.active_layers[this.group[0].projectUid] && this.active_layers[this.group[0].projectUid].meta.center) {
        if (this.$store.state.fly_active) {
          this.map.flyTo({
            center: this.active_layers[this.group[0].projectUid].meta.center.slice(0, 2),
            zoom: 16,
            speed: 5,
          });
        }
      }
    },
  },
  components: {
    project: Project,
  },
  computed: {
    ...mapState(["active_layers", "active_layer", "map", "draw"]),
    isActive() {
      return _.includes(this.group, this.active_layer);
    },
  },
};
</script>
<style lang="scss" scoped>
.flyto-btn {
  cursor: pointer;
  margin: 0 10px;
  color: #555c7e;
}

.group {
  margin-top: 10px;
  margin-bottom: 20px;
  box-shadow: 0 3px 6px 0 rgba(92, 126, 247, 0.3);
  border-radius: 10px;

  .card-header-title {
    margin: 0;
    cursor: pointer;
    text-align: left;
    padding: 0.5rem;
  }

  .active {
    color: #000;
    font-weight: 500;
  }

  .card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 1rem 0.5rem;
    padding-left: 0.1rem;
    padding-right: 0;
    transition: all 0.3s;

    &-close {
      display: none;
    }
  }
}

.group-menu {
  width: 100%;

  &__header {
    user-select: none;
    display: flex;
    justify-content: space-between;
  }

  &__content {
    padding: 0.5rem;

    &-row {
      display: flex;
      justify-content: space-evenly;
    }
  }
}

.group-menu__content {
  padding-left: 0;
}

.group-menu__content-row {
  margin-left: -0.1rem;
  display: flex;
  justify-content: space-around;
}

.field .label {
  font-family: Barlow-medium;
  color: #171e48;
  opacity: 0.7;
  font-size: 14px !important;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
</style>
